import styled, { css } from "styled-components";
import { colors } from "../../styles";

const Divider = styled.hr`
  border: 0;
  border-top: 1px solid ${colors.lightGray};

  ${(props) =>
    props.$center &&
    css`
      max-width: 50%;
    `}
`;

export default Divider;
